var TileStyleTypes;
(function (TileStyleTypes) {
    TileStyleTypes["WHITE"] = "white";
    TileStyleTypes["LIGHT"] = "light";
    TileStyleTypes["BURGUNDY"] = "burgundy";
    TileStyleTypes["BURGUNDYDARK"] = "burgundy-dark";
    TileStyleTypes["PURPLE"] = "purple";
    TileStyleTypes["PURPLELIGHT"] = "purple-light";
    TileStyleTypes["NIGHT"] = "night";
})(TileStyleTypes || (TileStyleTypes = {}));
var TileTypes;
(function (TileTypes) {
    TileTypes["REGULAR"] = "regular";
    TileTypes["SLIM"] = "slim";
})(TileTypes || (TileTypes = {}));

export { TileStyleTypes, TileTypes };
